"use strict";

const { get } = require("jquery");
const config = require('../../../../../config/locales_json/packs/private/admin/clients.json');
const language = $('body').data("language");

// Class definition

var ClientsDatatable = function() {
  // Private functions
  var _init = function() {
      var datatable = $('#kt_datatable_clients').KTDatatable({
          // datasource definition
          data: {
            type: 'remote',
            method: 'GET',
            source: {
              read: {
                url: '/admin/clients/get_clients.json',
                method: 'GET',
                map: function(data) {
                  if(data.data.statusCode) {
                    Swal.fire({
                      text: getTranslationValue(config, [language, "ClientsDatatable", "data", "Swalfire-error-text"], "Lo sentimos!, ")+data.data.message,
                      icon: "error",
                      buttonsStyling: false,
                      confirmButtonText: getTranslationValue(config, [language, "ClientsDatatable", "data", "Swalfire-error-confirmButtonText"], "Aceptar"),
                      customClass: {
                          confirmButton: "btn btn-fj-purple"
                      }
                    });

                    return false;
                  }

                  const totalText = getTranslationValue(config, [language, "ClientsDatatable", "data", "kt_subheader_total_Total"], " Total")
                  $("#kt_subheader_total").html(data.meta.total + totalText)

                  setTimeout(() => {
                    $('div#kt_datatable_clients .tp').tooltip('enable');
                  }, 2000);

                  return data.data
                }
              },
            },
            pageSize: 20,
            serverPaging: true,
            serverFiltering: true,
            serverSorting: true,
          },

          // layout definition
          layout: {
              scroll: false, // enable/disable datatable scroll both horizontal and vertical when needed.
              footer: false, // display/hide footer
          },

          // column sorting
          sortable: true,

          pagination: true,

          translate: {
            records: {
              processing: getTranslationValue(config, [language, "ClientsDatatable", "translate", "records-processing"], 'Cargando...'),
              noRecords: getTranslationValue(config, [language, "ClientsDatatable", "translate", "records-noRecords"], 'No hay registros disponibles')
            },
            toolbar: {
              pagination: {
                items: {
                  default: {
                    first: getTranslationValue(config, [language, "ClientsDatatable", "toolbar", "default-first"], 'Primero'),
                    prev: getTranslationValue(config, [language, "ClientsDatatable", "toolbar", "default-prev"], 'Anterior'),
                    next: getTranslationValue(config, [language, "ClientsDatatable", "toolbar", "default-next"], 'Siguiente'),
                    last: getTranslationValue(config, [language, "ClientsDatatable", "toolbar", "default-last"], 'Último'),
                    more: getTranslationValue(config, [language, "ClientsDatatable", "toolbar", "default-more"], 'Más páginas'),
                    input: getTranslationValue(config, [language, "ClientsDatatable", "toolbar", "default-input"], 'Página number'),
                    select: getTranslationValue(config, [language, "ClientsDatatable", "toolbar", "default-select"], 'Selecciona el tamaño de la página')
                  },
                  info: getTranslationValue(config, [language, "ClientsDatatable", "toolbar", "info"], 'Mostrando {{start}} - {{end}} de {{total}} clientes')
                }
              }
            }
          },

          // columns definition
          columns: [{
              field: 'name',
              title: getTranslationValue(config, [language, "ClientsDatatable", "columns", "name", "title"], 'Cliente'),
              width: 300,
              template: function(data) {
                var name = data.name;
                var logo = '<img class="" src="' + data.logo + '" alt="' + name + '"/>';

                const aTagTitle = getTranslationValue(config, [language, "ClientsDatatable", "columns", "name", "output-a-title"], "Ver ofertas");
                const divTagTitle = getTranslationValue(config, [language, "ClientsDatatable", "columns", "name", "output-div-title"], "Ver ofertas");

                var output = '<div class="d-flex align-items-center">\
                <a href="/admin/clientes/'+ data.slug +'/ofertas" class="icon mr-6 tp" data-toggle="tooltip" data-theme="dark" title="'+aTagTitle+'">\
                  <div class="symbol symbol-sm cont-logo-client">'+ logo +'</div>\
                </a>\
                  <div class="ml-5 cont-name-client">\
                    <a href="/admin/clientes/'+ data.slug +'/ofertas" class="icon mr-6 tp" data-toggle="tooltip" data-theme="dark" title="'+divTagTitle+'">\
                      <div class="text-dark-75 font-weight-bolder font-size-lg mb-0">' + name + '</div>\
                    </a>\
                  </div>\
                </div>';

                return output;
              },
          }, {
              field: 'nicename',
              title: getTranslationValue(config, [language, "ClientsDatatable", "columns", "nicename", "title"], "País"),
              width: 120,
              template: function(data) {
                var output = '<div class="font-weight-bolder mb-0">' + data.nicename + '</div>';

                return output;
            },
          }, {
              field: 'Status',
              title: getTranslationValue(config, [language, "ClientsDatatable", "columns", "Status", "title"], "Estado"),
              width: 100,
              // callback function support for column rendering
              template: function(row) {
                var clientID = row.id

                if(row.is_archived){
                  const spanText = getTranslationValue(config, [language, "ClientsDatatable", "columns", "Status", "row_is_archived", "output"], "Archivado");
                  var output = '<span class="label label-lg font-weight-bold label-inline label-closed">'+spanText+'</span>';
                } else if(row.is_active) {
                  const aTitle = getTranslationValue(config, [language, "ClientsDatatable", "columns", "Status", "row_is_active", "title"], "Editar Estado");
                  const spanText = getTranslationValue(config, [language, "ClientsDatatable", "columns", "Status", "row_is_active", "text"], "Activo");
                  var output = '<a href="/clients/'+ clientID +'/show_client_state" data-remote="true" id="status_'+ clientID +'"><span data-toggle="tooltip" data-theme="dark" title="'+aTitle+'" class="label label-lg font-weight-bold label-inline label-open">'+spanText+'</span></a>';
                } else {
                  const aTitle = getTranslationValue(config, [language, "ClientsDatatable", "columns", "Status", "else", "title"], "Editar Estado");
                  const spanText = getTranslationValue(config, [language, "ClientsDatatable", "columns", "Status", "else", "text"], "Inactivo");
                  var output = '<a href="/clients/'+ clientID +'/show_client_state" data-remote="true" id="status_'+ clientID +'"><span data-toggle="tooltip" data-theme="dark" title="'+aTitle+'" class="label label-lg font-weight-bold label-inline label-closed">'+spanText+'</span></a>';
                }

                return output;
              },
          }, {
              field: 'Actions',
              title: getTranslationValue(config, [language, "ClientsDatatable", "columns", "Actions", "title"], "Acciones"),
              sortable: false,
              width: 130,
              overflow: 'visible',
              autoHide: false,
              template: function(row) {
                if(row.counter_clients > 0){
                  const seeJobOffers = getTranslationValue(config, [language, "ClientsDatatable", "columns", "Actions", "row_counter_clients", "output_a_1"], "Ver ofertas");
                  const viewRecruiters = getTranslationValue(config, [language, "ClientsDatatable", "columns", "Actions", "row_counter_clients", "output_a_2"], "Ver Reclutadores");
                  const edit = getTranslationValue(config, [language, "ClientsDatatable", "columns", "Actions", "row_counter_clients", "output_a_3"], "Editar");
                  const deleteClient = getTranslationValue(config, [language, "ClientsDatatable", "columns", "Actions", "row_counter_clients", "output_a_4"], "Eliminar");

                  // Agregar al activar el plan
                  // <a href="/admin/clientes/activaciones?client_id='+ row.id +'" class="icon mr-5 tp" data-toggle="tooltip" data-theme="dark" title="Activaciones"><i class="fas fa-file-invoice-dollar fa-fw"></i></a>\

                  var output = '<div class="d-flex align-items-center container-actions-table">\
                    <a href="/admin/clientes/'+ row.slug +'/ofertas" class="icon mr-6 tp" data-toggle="tooltip" data-theme="dark" title="'+seeJobOffers+'"><i class="icon-oferts fas fa-clipboard-list"></i></a>\
                    <a href="/admin/clientes/'+ row.id +'/servicios" class="icon mr-5 tp" data-toggle="tooltip" data-theme="dark" data-remote="true" title="Servicios"><i class="fas fa-puzzle-piece fa-fw"></i></a>\
                    <a href="/admin/clientes/'+ row.id +'/edit" class="icon mr-5 tp" data-toggle="tooltip" data-theme="dark" title="'+edit+'"><i class="far fa-edit"></i></a>\
                    <button type="button" class="icon delete-button not-delete tp" data-toggle="tooltip" data-theme="dark" title="'+deleteClient+'" data-id="'+ row.id +'" data-toggle="modal" data-target="#delete_client_modal">\
                      <i class="fas fa-trash-alt"></i>\
                    </button>\
                  </div>';
                } else {
                  const seeJobOffers = getTranslationValue(config, [language, "ClientsDatatable", "columns", "Actions", "else", "output_a_1"], "Ver ofertas");
                  const viewRecruiters = getTranslationValue(config, [language, "ClientsDatatable", "columns", "Actions", "else", "output_a_2"], "Ver Reclutadores");
                  const edit = getTranslationValue(config, [language, "ClientsDatatable", "columns", "Actions", "else", "output_a_3"], "Editar");
                  const deleteClient = getTranslationValue(config, [language, "ClientsDatatable", "columns", "Actions", "else", "output_a_4"], "Eliminar");

                  // Agregar al activar el plan
                  // <a href="/admin/clientes/activaciones?client_id='+ row.id +'" class="icon mr-5 tp" data-toggle="tooltip" data-theme="dark" title="Activaciones"><i class="fas fa-file-invoice-dollar fa-fw"></i></a>\

                  var output = '<div class="d-flex align-items-center container-actions-table">\
                      <a href="/admin/clientes/'+ row.slug +'/ofertas" class="icon mr-6 tp" data-toggle="tooltip" data-theme="dark" title="'+seeJobOffers+'"><i class="icon-oferts fas fa-clipboard-list"></i></a>\
                      <a href="/admin/clientes/'+ row.id +'/servicios" class="icon mr-5 tp" data-toggle="tooltip" data-theme="dark" data-remote="true" title="Servicios"><i class="fas fa-puzzle-piece fa-fw"></i></a>\
                      <a href="/admin/clientes/'+ row.id +'/edit" class="icon mr-5 tp" data-toggle="tooltip" data-theme="dark" title="'+edit+'"><i class="far fa-edit"></i></a>\
                      <button type="button" class="icon delete-button tp" data-toggle="tooltip" data-theme="dark" title="'+deleteClient+'" data-id="'+ row.id +'" data-toggle="modal" data-target="#delete_client_modal">\
                        <i class="fas fa-trash-alt"></i>\
                      </button>\
                  </div>';
                }

                return output;
              }
          }],
          search: {
            input: $('#kt_subheader_clients_search_form'),
          },
      });
  };

  return {
    // public functions
    init: function() {
        _init();
    },
  };
}();

jQuery(document).ready(function() {
    if($("#kt_datatable_clients").length > 0){
        ClientsDatatable.init();
    }

    /*************
     * ELIMINAR CLIENTES
     *
     * - Logica de activacion de modal,
     * - Asignacion de informacion a hidden field del modal
     * - Validacion y ejecución del formulario
     */
    // Al hacer click en eliminar un cliente
    $("#kt_datatable_clients").on("click", ".delete-button", function(e){
        $('#delete_client_modal').modal('toggle')
        // Obtiene el id del cliente
        var clientId = $(this).attr("data-id")
        // Asigna el id del cliente en el campo hidden del modal
        $("#delete_client_modal #hidden_modal_id").val(clientId)
        // Se asigna la url correspondiente
        var url = '/admin/clientes/'+ clientId;
        $("#form_modal_delete_client").attr("action", url)
        // Si el cliente se debe archivar porque tiene ofertas
        if($(this).hasClass("not-delete")){
            const descriptionText = getTranslationValue(config, [language, "click-delete-button", "description_text"], "Este cliente ya ha creado ofertas, no se puede eliminar pero si quedará archivado. Esta acción no se puede revertir.");
            const btnText = getTranslationValue(config, [language, "click-delete-button", "btn_text"], "Archivar");

            // Modifica la descripcion del modal
            $("#delete_client_modal .modal-body .description").text(descriptionText)
            // Modifica el texto del boton
            $("#delete_client_modal .modal-footer #send_modal_delete_client_form").text(btnText)
            // Agrega la clase not-delete para que al enviar el formulario muestre el texto de "Archivando..."
            $("#delete_client_modal .modal-footer #send_modal_delete_client_form").addClass("not-delete")
        // Si la oferta debe eliminarse modifica la info del modal por si anteriormente el modal fue abierto
        // por alguna oferta que se debio archivar
        } else {
            const descriptionText = getTranslationValue(config, [language, "click-delete-button", "else_description_text"], "Esta acción no se puede revertir.");
            const btnText = getTranslationValue(config, [language, "click-delete-button", "else_btn_text"], "Eliminar");

            // Modifica la descripcion del modal
            $("#delete_client_modal .modal-body .description").text(descriptionText)
            // Modifica el texto del boton
            $("#delete_client_modal .modal-footer #send_modal_delete_client_form").text(btnText)
            // Quita la clase not-delete para que al enviar el formulario muestre el texto de "Eliminando..."
            $("#delete_client_modal .modal-footer #send_modal_delete_client_form").removeClass("not-delete")
        }

    })

    // Al cerrar el modal limpia la url y el hidden
    $("#delete_client_modal .close").on("click", function(e){
        cleanClientModalFields()
    })

    // Al hacer click en confirmar eliminacion del cliente
    $("#delete_client_modal #cancel_modal_delete_client_form").on("click", function(e){
        cleanClientModalFields()
    })

    // Al hacer click en enviar cliente
    $("#delete_client_modal #send_modal_delete_client_form").on("click", function(e){
        // Valida que el campo hidden tenga información
        var clientId = $("#delete_client_modal #hidden_modal_id").val()
        // Si tiene informacion ejecuta el formulario
        if(clientId.length > 0) {
            // Se desabilitan las acciones
            // Si se esta archivando un cliente
            if($(this).hasClass("not-delete")){
                const disabledText = getTranslationValue(config, [language, "click-hidden_modal_id", "clientId-length-not-delete"], "Archivando...");
                // Cambia el texto del boton a Archivando
                $(this).addClass("disabled").text(disabledText)
            // De lo contrario esta eliminando el cliente
            } else {
                const disabledText = getTranslationValue(config, [language, "click-hidden_modal_id", "clientId-length-not-delete-else"], "Eliminando...");
                // Cambia el texto del boton a Eliminando
                $(this).addClass("disabled").text(disabledText)
            }

            $("#delete_client_modal #cancel_modal_delete_client_form").addClass("disabled")
            $("#delete_client_modal #close_delete_client_modal").addClass("disabled")
            $("#form_modal_delete_client").submit()
        } else {
            const errorText = getTranslationValue(config, [language, "click-hidden_modal_id", "else-clientId-length"], "Hubo un problema y no se pudo eliminar la oferta. Por favor intente más tarde.");
            // Si no se puede eliminar
            $(".modal-body").find(".error-modal").remove()
            $(".modal-body").prepend('<div class="error-modal"><i class="fas fa-times-circle"></i><p>'+errorText+'</p></div>')
        }
    })

    // Limpia el campo hidden y la url del form
    function cleanClientModalFields(){
        // Limpia si hay errores
        $(".modal-body").find(".error-modal").remove()
        // Limpia el campo hidden
        $("#delete_client_modal #hidden_modal_id").val(null)
        // Se limpia la url correspondiente
        var url = '';
        $("#form_modal_delete_client").attr("action", url)
    }
    /*************
     * FIN ELIMINAR CLIENTE
     */

    $('div#changeClientStateModal').on("click", "#change_client_state", function(e){
      const changeStateText = getTranslationValue(config, [language, "click-change_client_state", "disabled-text"], "Enviando Información...");
      $(this).addClass("disabled").text(changeStateText);
      $("div#changeClientStateModal").addClass("disabled");
    })
});

function getTranslationValue(config, keys, defaultValue) {
	if (keys.length <= 1) return defaultValue;
  
	let currentTranslation;
	let firstIteration = true;
  
	for (let key of keys) {

	  if (firstIteration) {

      if (config[key]) {
        currentTranslation = config[key];
        firstIteration = false;
      } else {
        firstIteration = false;
        return defaultValue;
      }
	  } else {
      
      if (currentTranslation[key]) {
        currentTranslation = currentTranslation[key];
      } else {
        return defaultValue;
      }
	  }
	}

	return currentTranslation;
}
